module.exports = __webpack_public_path__ + "img/shingaku-exam.13fc6d61.png";